import { useDialogState } from '@user/utils/useDialogState'
import { UpdateReferralDrawerState } from './typings'

export function useUpdateReferralDrawer(): UpdateReferralDrawerState {
  const [
    updateReferralDrawerOpen,
    onOpenUpdateReferralDrawer,
    onCloseUpdateReferralDrawer,
  ] = useDialogState()

  return {
    updateReferralDrawerOpen,
    onOpenUpdateReferralDrawer,
    onCloseUpdateReferralDrawer,
  }
}
